import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock("div", {
    class: "emp-card",
    key: `emp-${_ctx.employeeId}`
  }, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.dsContracteMunca,
      ref: "dataGridRef",
      "allow-column-reordering": true,
      "allow-column-resizing": true,
      "column-auto-width": false,
      "show-borders": true,
      "key-expr": "Id"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxFilterRow, { visible: false }),
        _createVNode(_component_DxPaging, {
          "page-size": 10,
          "page-index": 0
        }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxScrolling, {
          mode: "standard",
          "show-scrollbar": 'always'
        }),
        _createVNode(_component_DxColumnFixing, { enabled: true }),
        _createVNode(_component_DxEditing, {
          "allow-updating": true,
          mode: "popup"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              closeOnOutsideClick: false,
              showCloseButton: false,
              width: 700,
              height: 450,
              "show-title": false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxToolbarItem, { template: _ctx.customTitleTemplate }, null, 8, ["template"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.saveButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.dangerButtonOptions
                }, null, 8, ["options"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TransferInRevisal",
          width: "150"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "StareCurenta",
          width: "150"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CorId",
          width: "170",
          caption: "COR Cod"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CorVersiune",
          width: "110",
          caption: "COR Versiune"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataConsemnare",
          width: "130"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataCreare",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataIncepereActivitate",
          width: "140"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataIncheiereContract",
          width: "140"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DateContractVechi",
          width: "140"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Detalii",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "AngajatorSursaCui",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "AngajatorSursaDenumire",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataImport",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TipMutare",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ExceptieDataSfarsit",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NumarContract",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NumereContractVechi",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Radiat",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "SalariuBrut",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "SporTipNume",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TimpMuncaNorma",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TimpMuncaRepartizare",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TimpMuncaIntervalTimp",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TimpMuncaDurata",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TipContract",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TipNorma",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataReactivare",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "EchipamentIndividualProtectie",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "EchipamentIndividualLucru",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "MaterialeIgienicoSanitare",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "AlimentatieProtectie",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "AlteDrepturiObligatiiSsm",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NumarContractColectivMunca",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataIncheiereContractColectiv",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "SeriePermisMunca",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NumarPermisMunca",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataPermisMunca",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "LocatiaDesfasurariiActivitatii",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NrLuniActivitate",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ConcediuOdihnaSuplimentar",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataPlataSalariu",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "PerioadaProba",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TipPreaviz",
          width: "100"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "PerioadaPreaviz",
          width: "100"
        }),
        _createVNode(_component_DxToolbar, null, {
          default: _withCtx(() => [
            (_ctx.$route.name !== 'Contracte')
              ? (_openBlock(), _createBlock(_component_DxItem, {
                  key: 0,
                  location: "before"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "continue-application",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToContracts && _ctx.goToContracts(...args)))
                    }, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", { class: "folder" }, [
                          _createElementVNode("div", { class: "top" }, [
                            _createElementVNode("svg", { viewBox: "0 0 24 27" }, [
                              _createElementVNode("path", { d: "M0 0h24v27H0z" })
                            ])
                          ]),
                          _createElementVNode("div", { class: "paper" })
                        ]),
                        _createElementVNode("div", { class: "pencil" })
                      ], -1),
                      _createTextVNode(" Vezi pagina de contracte ", -1)
                    ]))])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.$route.name == 'Contracte')
              ? (_openBlock(), _createBlock(_component_DxItem, {
                  key: 1,
                  location: "before"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxButton, {
                      text: "Înapoi",
                      icon: "arrowleft",
                      type: "default",
                      class: "back-button",
                      onClick: _ctx.goBack
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.$route.name == 'Contracte')
              ? (_openBlock(), _createBlock(_component_DxItem, {
                  key: 2,
                  location: "before"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxButton, {
                      text: "Corecție",
                      type: "default",
                      class: "back-button"
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.$route.name == 'Contracte')
              ? (_openBlock(), _createBlock(_component_DxItem, {
                  key: 3,
                  location: "before"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxButton, {
                      text: "Suspendare",
                      type: "default",
                      class: "back-button"
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.$route.name == 'Contracte')
              ? (_openBlock(), _createBlock(_component_DxItem, {
                  key: 4,
                  location: "before"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxButton, {
                      text: "Detașare",
                      type: "default",
                      class: "back-button"
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.$route.name == 'Contracte')
              ? (_openBlock(), _createBlock(_component_DxItem, {
                  key: 5,
                  location: "before"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxButton, {
                      text: "Schimb. Loc Munca",
                      type: "default",
                      class: "back-button"
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.$route.name == 'Contracte')
              ? (_openBlock(), _createBlock(_component_DxItem, {
                  key: 6,
                  location: "before"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxButton, {
                      text: "Încetare/Reactivare",
                      type: "default",
                      class: "back-button"
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.$route.name == 'Contracte')
              ? (_openBlock(), _createBlock(_component_DxItem, {
                  key: 7,
                  location: "before"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxButton, {
                      text: "Istoric",
                      type: "default",
                      class: "back-button"
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.$route.name == 'Contracte')
              ? (_openBlock(), _createBlock(_component_DxItem, {
                  key: 8,
                  location: "before"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxButton, {
                      text: "L153",
                      type: "default",
                      class: "back-button"
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_DxItem, { location: "after" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "add",
                  type: "success",
                  onClick: _ctx.onAddClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.addPopupVisible,
      "show-title": true,
      height: 450,
      width: 700
    }, {
      title: _withCtx(() => [...(_cache[2] || (_cache[2] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Adăugare ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxForm, {
          "col-count": 2,
          "data-source": _ctx.formData,
          "label-alignment": "center"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxSimpleItem, { "data-field": "CourseCpv" })
          ]),
          _: 1
        }, 8, ["data-source"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.addButtonOptions
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: _ctx.closeButtonOptions
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}